import React from 'react';
import styles from './index.module.scss';

// Components
import { Card, Table, Button } from 'react-bootstrap';

const DevicesList = (props) => {
    return (
        <Card className={styles.DevicesList}>
            <Card.Body>
                <h5>Devices List</h5>
                <hr />
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Order</th>
                            <th>Name</th>
                            <th>Price</th>
                            <th>Modified</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Apple Iphone SE</td>
                            <td>$99.99</td>
                            <td>10/27/2020 9:00am</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">Edit</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                                <Button className={styles.Button} size="sm" variant="warning">Change Order</Button>
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Samsung Galaxy Core Prime</td>
                            <td>$79.99</td>
                            <td>10/27/2020 9:00am</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">Edit</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                                <Button className={styles.Button} size="sm" variant="warning">Change Order</Button>
                            </td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Samsung Galaxy A11</td>
                            <td>$199.99</td>
                            <td>10/27/2020 9:00am</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">Edit</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                                <Button className={styles.Button} size="sm" variant="warning">Change Order</Button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    )
}

export default DevicesList;